import * as React from 'react';
import { Hr, Paragraph } from '../../../../elements';
import TwoColRow from './TwoColRow';
const PersonalDebtRow = ({ value, i18n, formatDate }) => {
    const debtRelief = i18n('service.checkpoints.PersonalDebtRelief');
    return (React.createElement(React.Fragment, null,
        React.createElement(Paragraph, { className: 'HeadingSpace', bold: true }, debtRelief),
        value.debtReliefs.length === 0 ? (React.createElement(TwoColRow, { label: debtRelief, value: i18n('service.checkpoints.PersonalDebtRelief.None') })) : (React.createElement(React.Fragment, null, value.debtReliefs.map(relief => (React.createElement(React.Fragment, { key: `${relief.debtReliefDate}` },
            React.createElement(TwoColRow, { label: debtRelief, value: i18n(`service.checkpoints.PersonalDebtRelief.${relief.debtReliefType}`) }),
            relief.debtReliefType !== 'None' && (React.createElement(TwoColRow, { className: "ReadReport__debtRelief", label: i18n('common.date'), value: formatDate(relief.debtReliefDate) }))))))),
        React.createElement(Hr, null)));
};
export default PersonalDebtRow;
